@if (entry.value) { <span>{{entry.value}}</span> }

@if (entry.toggler) {
  <toggler [currentValue]="entry.toggler.init"
           [leftValue]="entry.toggler.left"
           [rightValue]="entry.toggler.right"
           (togglerCallback)="entry.toggler.click($event)">
  </toggler>
}

@if (entry.editableInput) {
  <editable-input [index]="entry.editableInput.index"
                  [editBox]="entry.editableInput.editBox"
                  [type]="entry.editableInput.type"
                  [value]="entry.editableInput.value"
                  [maxValue]="entry.editableInput.maxValue"
                  [valueType]="entry.editableInput.valueType"
                  [postValue]="entry.editableInput.postValue"
                  [showEdit]="entry.editableInput.showEdit"
                  (toggleEditBox)="entry.editableInput.toggleEditBox($event)"
                  (onValueChange)="entry.editableInput.onValueChange($event)">
  </editable-input>
}

@for (child of entry.children; track child; let childIndex = $index) {
  <entries-nested-child [ngClass]="child.class"
                        [child]="child"
                        [indexes]="mergeArray(indexes, childIndex)"
                        [routerLink]="child.routerLink"
                        [state]="child.routerLinkState"
                        (click)="callbackHandler($event, childIndex)"
                        (callback)="callbackHandler($event)">
  </entries-nested-child>
}
